<template>
  <div
    id="floorplans"
    :class='{planActive: selectedPlan !== null, hidden: inquireOpened}'
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <app-plan
        class="plan-component"
        :plan="selectedPlan"
        :section="data"
        :soldUnits="soldUnits"
        :filters="filters"
        v-if="selectedPlan"
      ></app-plan>
    </transition>

    <div class="content" v-show="!selectedPlan">
      <!-- Filters -->
      <div class="filters">
        <div class="desktop_logo">
          <img
            class="small_logo"
            :src="small_logo"
            alt="The Livmore - Refined Residential Rentals"
            role="img"
          />
        </div>
        <div class="filter-block">
          <h1 class="title">suite type</h1>
          <div class="checkbox_container">
            <div
              class="checkbox_row"
              v-for="type in filters.types"
              :key="type.name"
            >
              <input
                class="custom-check"
                type="checkbox"
                :id="type.name"
                v-model="type.active"
                @change="updateFilters()"
              />
              <label :for="type.name">{{ type.label }}</label>
            </div>
          </div>
        </div>
        <div class="filter-block">
          <h2 class="title level">level</h2>
          <div class="checkbox_container">
            <div
              class="checkbox_row"
              v-for="level in filters.levels"
              :key="level.name"
            >
              <input
                class="custom-check"
                type="checkbox"
                :id="level.name"
                v-model="level.active"
                @change="updateFilters()"
              />
              <label :for="level.name">{{ level.label }}</label>
            </div>
          </div>
        </div>
        <div class="filter-block">
          <h2 class="title">direction</h2>
          <div class="checkbox_container">
            <div
              class="checkbox_row"
              v-for="dir in filters.directions"
              :key="dir.name"
            >
              <input
                class="custom-check"
                type="checkbox"
                :id="dir.label"
                v-model="dir.active"
                @change="updateFilters()"
              />
              <label :for="dir.label">{{ dir.label }}</label>
            </div>
          </div>
        </div>
      </div>

      <div
        class="filters_mobile"
        :class="{active: filterIndex < 3}"
      >
        <div class="selected_filters">
          <span v-if="activeFilterCount('types') > 0">1. </span><span>{{ mobileActiveFiltersTypes }} </span>
        </div>
        <div class="selected_filters">
          <!-- <span v-if="activeFilterCount('levels') > 0">2. </span><span v-for="level in filters.levels" :key="level.name" v-if="level.active">{{ level.label }} </span> -->
          <span v-if="activeFilterCount('levels') > 0">2. </span><span>{{ mobileActiveFiltersLevels }} </span>
        </div>
        <div class="selected_filters">
          <span v-if="activeFilterCount('directions') > 0">3. </span><span>{{ mobileActiveFiltersDir }} </span>
        </div>
        <div
          class="filter-block mobile"
          :class="{active: filterIndex == 0}"
        >
          <div class="title">
            <div class="title_num">1.</div>
            <h1 class="title_question">
              which suite types are you interested in?
            </h1>
          </div>
          <div class="checkbox_container">
            <!-- <div
              class="checkbox_row"
              v-for="type in filters.types"
              :key="type.name"
            >
              <input
                class="custom-check"
                type="checkbox"
                :id="'mobile_' + type.name"
                v-model="type.active"
              />
              <label :for="'mobile_' + type.name">{{ type.label }}</label>
            </div> -->
            <ul class="checkboxes">
              <li
                v-for="type in filters.types"
                :key="'mobile_' + type.name"
              >
                <div
                  class="mobile-check"
                  role="checkbox"
                  aria-checked="false"
                  tabindex="0"
                  :id="'mobile_' + type.name"
                  @click="toggleInput(type)"
                >
                  {{ type.label }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="filter-block mobile"
          :class="{active: filterIndex == 1}"
        >
          <div class="title">
            <div class="title_num">2.</div>
            <h1 class="title_question">
              which floors are you interested in?
            </h1>
          </div>
          <div class="checkbox_container">
            <!-- <div
              class="checkbox_row"
              v-for="level in filters.levels"
              :key="level.name"
            >
              <input
                class="custom-check"
                type="checkbox"
                :id="'mobile_' + level.name"
                v-model="level.active"
              />
              <label :for="'mobile_' + level.name">{{ level.label }}</label>
            </div> -->
            <ul class="checkboxes">
              <li
                v-for="level in filters.levels"
                :key="'mobile_' + level.name"
              >
                <div
                  class="mobile-check"
                  role="checkbox"
                  aria-checked="false"
                  tabindex="0"
                  :id="'mobile_' + level.name"
                  @click="toggleInput(level)"
                >
                  {{ level.label }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="filter-block mobile"
          :class="{ active: filterIndex == 2 }"
        >
          <div class="title">
            <div class="title_num">3.</div>
            <h1 class="title_question">
              which directions are you interested in?
            </h1>
          </div>
          <div class="checkbox_container">
            <!-- <div
              class="checkbox_row"
              v-for="dir in filters.directions"
              :key="dir.name"
            >
              <input
                class="custom-check"
                type="checkbox"
                :id="'mobile_' + dir.label"
                v-model="dir.active"
              />
              <label :for="'mobile_' + dir.label">{{ dir.label }}</label>
            </div> -->
            <ul class="checkboxes">
              <li
                v-for="dir in filters.directions"
                :key="'mobile_' + dir.name"
              >
                <div
                  class="mobile-check"
                  role="checkbox"
                  aria-checked="false"
                  tabindex="0"
                  :id="'mobile_' + dir.name"
                  @click="toggleInput(dir)"
                >
                  {{ dir.label }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="next_container">
          <button
            class="next_btn"
            @click="advanceFilter()"
          >
            <span v-if="filterIndex < 2">next</span>
            <span v-else>show me floorplans ({{filteredPlans.length}})</span>
          </button>
          <button
            class="skip_btn"
            @click="skipFilters()"
          >
            <span>skip</span>
          </button>
        </div>
        <div class="clear">

        </div>
      </div>

      <!-- Plan list -->
      <div class="plan-list">
        <div
          class="no_plans"
          v-if="filteredPlans.length === 0 && data !== undefined && data.plans !== undefined"
        >
          No units fit your criteria.
        </div>
        <div
          class="plan"
          v-for="plan in filteredPlans"
          :key="plan.id"
        >
          <!-- <div class="occupancy">
          occupancy january 2016
        </div> -->
          <div class="fp_thumb_container">
            <transition
              name="fade"
              mode="out-in"
            >
              <div
                class="fp_thumb"
                :key="baseUrl + getImage('fp', plan)"
                :style="{'background-image': 'url(' + baseUrl + getImage('fp', plan) + ')'}"
                :aria-label="filteredPlans[planIndex].name + ' thumbnail floorplan'"
                role="img"
              ></div>
            </transition>
          </div>
          <div class="details_container">
            <div class="details">
              <div
                class="title"
                v-html="plan.name"
              >
              </div>
              <div class="detail_block">
                <div class="bed-type">
                  {{ getType(plan) }}
                </div>
                <div class="size">
                  {{ plan.conditions[0].interior }} Square Feet
                </div>
              </div>
              <div class="detail_block">
                <div class="direction">
                  Faces {{ getDir(plan) }}
                </div>
                <div class="baths">
                  {{ getBathroom(plan) }}
                </div>
              </div>
              <div class="view">
                <button
                  @click="selectPlan(plan)"
                  :aria-label="plan.name + ' - Explore Suites'"
                >
                  explore suites
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="mobile-list"
        class="plan-list mobile"
        :class="{ 'filterActive': filterIndex < 3, 'hidden': inquireOpened }"
      >
        <div class="content" v-show="!showAccessible">

          <div class="swipe">
            <button
              class="mobile-plan-nav icon-arrow-left icons"
              aria-label="Previous Result"
              @click="nextPlan(false)"
            >
            </button>
            <span>swipe left or right to change floor plans</span>
            <button
              class="mobile-plan-nav icon-arrow-right icons"
              aria-label="Next Result"
              @click="nextPlan(true)"
            >
            </button>
          </div>
          </button>
          <div
            id="mobilePlan"
            class="plan"
            v-if="filteredPlans.length > 0"
          >
            <div class="fp_thumb_container">
              <a
                class="fancy_thumb"
                :href="baseUrl + getImage('fp', filteredPlans[planIndex])"
              >
                <div
                  class="fp_thumb"
                  :style="{'background-image': 'url(' + baseUrl + getImage('fp', filteredPlans[planIndex]) + ')'}"
                  :aria-label="filteredPlans[planIndex].name + ' thumbnail floorplan'"
                  role="img"
                ></div>
                  <!-- @click="openFancy(baseUrl + getImage('fp', filteredPlans[planIndex]))" -->
              </a>
            </div>
            <div class="details_container">
              <div class="details">
                <div
                  class="title"
                  v-html="filteredPlans[planIndex].name"
                >
                </div>
                <div class="detail_block">
                  <div class="bed-type">
                    {{ getType(filteredPlans[planIndex]) }}
                  </div>
                  <div class="size">
                    {{ filteredPlans[planIndex].conditions[0].interior }} Square Feet
                  </div>
                  <div class="direction">
                    Faces {{ getDir(filteredPlans[planIndex]) }}
                  </div>
                  <!-- <div class="baths"> -->
                  <!-- 1 Bathroom -->
                  <!-- </div>  -->
                </div>
                <div class="detail_block">
                  <button class="show-accessible" @click="showAccessible = !showAccessible">Show Accessible Description</button>
                </div>
                <div class="view">
                  <button @click="selectPlan(filteredPlans[planIndex])">show keyplate</button>
                  <button @click="inquirePlan(filteredPlans[planIndex])">inquire about this plan</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accessible-desc" v-show="showAccessible">
          <div class="desc">
            {{ planDesc }}
          </div>
          <button class="show-accessible hide-btn" @click="showAccessible = !showAccessible">Hide Accessible Description</button>
        </div>
      </div>

      <div
        class="loader"
        v-if="data !== undefined && data.plans === undefined"
      >
        <img :src="ovalLoader" />
        <div>
          loading floor plans...
        </div>
      </div>

    </div>
    <button
      class="icon-arrow-up icons top-btn"
      aria-label="scroll to top"
      @click="scrollToTop()"
    ></button>
  </div>
</template>

<script>
/* global $, ADhoc */
import EventBus from './../EventBus';
import PlanComponent from './Plan';

export default {
  name: 'app-floorplans',
  props: ['data', 'soldUnits'],
  components: {
    'app-plan': PlanComponent
  },
  data() {
    return {
      activePage: 'app-floorplans',
      baseUrl:
        'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/',
      filters: {
        types: [
          { name: 'studio', label: 'Studio', active: false },
          { name: 'one', label: '1 Bedroom', active: false },
          { name: 'two', label: '2 Bedroom', active: false },
          // { name: 'twoDen', label: '2 Bedroom + Den', active: false },
          { name: 'three', label: '3 Bedroom', active: false }
        ],
        levels: [
          {
            name: 'level2',
            label: 'levels 2-10',
            min: 2,
            max: 10,
            active: false
          },
          {
            name: 'level11',
            label: 'levels 11-20',
            min: 11,
            max: 20,
            active: false
          },
          {
            name: 'level21',
            label: 'levels 21-35',
            min: 21,
            max: 35,
            active: false
          },
          {
            name: 'level36',
            label: 'levels 36-42',
            min: 36,
            max: 42,
            active: false
          },
          {
            name: 'level43',
            label: 'levels 43',
            min: 43,
            max: 43,
            active: false
          }
        ],
        directions: [
          { name: 'n', label: 'North', active: false },
          { name: 'e', label: 'East', active: false },
          { name: 's', label: 'South', active: false },
          { name: 'w', label: 'West', active: false }
        ]
      },
      filteredPlans: [],
      likedPlans: [],
      likedPlansOpen: false,
      selectedPlan: null,
      small_logo: 'static/img/landing/small_logo.png',
      filterIndex: 0,
      planIndex: 0,
      touchstartX: 0,
      touchstartY: 0,
      touchendX: 0,
      touchendY: 0,
      phoneDetected: false,
      initFancy: false,
      ovalLoader: 'static/img/oval.svg',
      inquireOpened: false,
      showAccessible: false
    };
  },
  methods: {
    initSwipe() {
      const gestureZone = document.getElementById('mobile-list');

      gestureZone.addEventListener(
        'touchstart',
        event => {
          this.touchstartX = event.changedTouches[0].screenX;
          this.touchstartY = event.changedTouches[0].screenY;
        },
        false,
        this
      );

      gestureZone.addEventListener(
        'touchend',
        event => {
          this.touchendX = event.changedTouches[0].screenX;
          this.touchendY = event.changedTouches[0].screenY;
          this.handleGesture();
        },
        false,
        this
      );
    },
    handleGesture() {
      // if (touchendX < touchstartX) {
      //   console.log('Swiped left');
      // }
      //
      // if (touchendX > touchstartX) {
      //   console.log('Swiped right');
      console.log('swiped');
      if (
        this.touchendX < this.touchstartX &&
        Math.abs(this.touchendX - this.touchstartX) > 30
      ) {
        this.planIndex += 1;
        if (this.planIndex >= this.filteredPlans.length) {
          this.planIndex = 0;
        }
      }

      if (
        this.touchendX > this.touchstartX &&
        Math.abs(this.touchendX - this.touchstartX) > 30
      ) {
        this.planIndex -= 1;
        if (this.planIndex < 0) {
          this.planIndex = this.filteredPlans.length - 1;
        }
      }
      // if (touchendY === touchstartY) {
      //   console.log('Tap');
      // }
    },
    nextPlan(next) {
      if (next) {
        this.planIndex += 1;
        if (this.planIndex >= this.filteredPlans.length) {
          this.planIndex = 0;
        }
      } else {
        this.planIndex -= 1;
        if (this.planIndex < 0) {
          this.planIndex = this.filteredPlans.length - 1;
        }
      }
    },
    calcVH() {
      if (window.innerHeight > window.innerWidth || window.innerWidth < 1281) {
        const vH =
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          ) - 75;
        const addrBarHeight = 75;
        document
          .getElementById('floorplans')
          .setAttribute('style', 'height:' + vH + 'px;');

        // const planSize = (0.7 * vH);
        // console.log(planSize, vH);
        // const mobilePlan = document.getElementById('mobilePlan');
        // if (mobilePlan) {
        //   document.getElementById('mobilePlan').setAttribute('style', 'height:' + planSize + 'px;');
        // }
      } else {
        const vH = Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        );
        document
          .getElementById('floorplans')
          .setAttribute('style', 'height:' + vH + 'px;');
      }
    },
    suiteBetweenFloors(suite) {
      let inFloors = false;
      const suiteFloor = parseInt(suite.floor, 10);
      this.levels.forEach(levelSet => {
        if (suiteFloor >= levelSet.min && suiteFloor <= levelSet.Max) {
          inFloors = true;
        }
      });
      return true;
    },
    // Filter Management
    betweenFloors(levels, plan) {
      if (levels.min === 0 && levels.max === 99) {
        return true;
      }
      let minLvl = 99;
      let maxLvl = 0;

      plan.conditions[0].suites.forEach(suite => {
        const floor = parseInt(suite.floor, 0);
        if (floor > maxLvl) {
          maxLvl = floor;
        }
        if (floor < minLvl) {
          minLvl = floor;
        }
      });
      // Just need an overlap
      if (minLvl <= levels.max && maxLvl >= levels.min) {
        return true;
      }
      return false;
    },
    getLevels() {
      let minLevel = 99;
      let maxLevel = 0;
      const levels = this.filters.levels.filter(lvl => lvl.active);

      if (levels.length === 0) {
        return { min: 0, max: 99 };
      }

      levels.forEach(lvl => {
        if (lvl.min < minLevel) {
          minLevel = lvl.min;
        }
        if (lvl.max > maxLevel) {
          maxLevel = lvl.max;
        }
      });
      return { min: minLevel, max: maxLevel };
    },
    getBathroom(plan) {
      const baths = parseInt(plan.filter, 10);
      if (baths === 1) {
        return '1 Bathroom';
      }
      return baths + ' Bathrooms';
    },
    getType(plan) {
      switch (plan.type) {
        case 'one': {
          return '1 Bedroom';
        }
        case 'oneDen': {
          return '1 Bedroom + Den';
        }
        case 'two': {
          return '2 Bedroom';
        }
        case 'twoDen': {
          return '2 Bedroom + Den';
        }
        case 'three': {
          return '3 Bedroom';
        }
        case 'threeDen': {
          return '3 Bedroom + Den';
        }
        default: {
          return 'Studio';
        }
      }
    },
    getDir(plan) {
      let dir = plan.dir;
      if (plan.conditions[0].condition_name !== '') {
        dir = plan.conditions[0].condition_name;
      }
      switch (dir) {
        case 'n': {
          return 'North';
        }
        case 'ne': {
          return 'Northeast';
        }
        case 'e': {
          return 'East';
        }
        case 'se': {
          return 'Southeast';
        }
        case 's': {
          return 'South';
        }
        case 'sw': {
          return 'Southwest';
        }
        case 'w': {
          return 'West';
        }
        case 'nw': {
          return 'Northwest';
        }
        default: {
          return '';
        }
      }
    },
    // mobile only
    restartFilter() {
      this.filterIndex = 0;
      EventBus.$emit('filterStatus', true);
    },
    advanceFilter() {
      this.filterIndex += 1;
      this.planIndex = 0;
      if (this.filterIndex >= 3) {
        this.updateFilters();
        setTimeout(
          () => {
            this.initFancyBox();
          },
          250,
          this
        );
        EventBus.$emit('filterStatus', false, this.filterIndex);
      } else {
        EventBus.$emit('filterStatus', true, this.filterIndex);
      }
    },
    skipFilters() {
      this.filterIndex = 3;
      this.planIndex = 0;
      this.updateFilters();
      setTimeout(
        () => {
          this.initFancyBox();
        },
        250,
        this
      );
      EventBus.$emit('filterStatus', false);
    },
    updateFilters() {
      const activePlans = [];
      const types = this.filters.types
        .filter(type => type.active)
        .map(type => type.name);
      const levels = this.getLevels();
      console.log(this.filters.levels);
      const dirs = this.filters.directions
        .filter(dir => dir.active)
        .map(dir => dir.name);

      this.data.plans.forEach(plan => {
        if (
          (types.indexOf(plan.type) > -1 || types.length === 0) &&
          this.betweenFloors(levels, plan)
        ) {
          let planDir = plan.dir;
          if (plan.conditions[0].condition_name !== '') {
            planDir = plan.conditions[0].condition_name;
          }
          let dirFound = false;
          for (let i = 0; i < dirs.length; i += 1) {
            if (planDir.indexOf(dirs[i]) > -1) {
              dirFound = true;
              break;
            }
          }
          if (dirFound || dirs.length === 0) {
            activePlans.push(plan);
          }
          // if (dirs.indexOf(plan.dir) > -1 || dirs.length === 0) {
          //   activePlans.push(plan);
          // }
        }
      });
      this.filteredPlans.length = 0;
      this.filteredPlans = activePlans;
    },
    // Plan open close
    setPlans() {
      // console.log('dataReady', this.data);
      this.filteredPlans.push(...this.data.plans);
    },
    selectPlan(plan) {
      EventBus.$emit('openPlan');
      this.selectedPlan = plan;
      // console.log('selectPlan', plan.name);
      setTimeout(
        () => {
          EventBus.$emit('setKP', this.selectedPlan);
        },
        200,
        this
      );

      /* analytics */
      try {
        ADhoc.track(
          {
            type: 'floorplan',
            type_id: plan.id,
            event: 'click',
            project_id: 412 // optional
          },
          true
        );
      } catch (e) {
        console.error(e);
      }
    },
    // Mobile only
    inquirePlan(plan) {
      // this.inquireOpen = true;
      EventBus.$emit('openInquire', plan, this.filters);
    },
    closePlan() {
      this.selectedPlan = null;
    },
    getImage(type, plan) {
      let url = '';
      if (
        plan !== null &&
        plan !== undefined &&
        plan.conditions[0] !== undefined
      ) {
        url = plan.conditions[0].images.find(img => img.type === type).url;
      }
      return url;
    },
    initFancyBox() {
      if (!this.initFancy) {
        console.log('fancybox init');
        // $('.fancy_thumb').fancybox({
        //   touch: {
        //     vertical: false
        //   },
        //   btnTpl: {
        //     close: '<button class="fancy-close" data-fancybox-close><span class="ion-android-close"></span></button>'
        //   }
        // });
        $().fancybox({
          selector: '.fancy_thumb',
          loop: true,
          touch: {
            vertical: false
          },
          btnTpl: {
            close:
              '<button class="fancy-close" aria-label="close" data-fancybox-close><span class="ion-android-close"></span></button>'
          },
          caption: '&nbsp;'
        });
        this.initFancy = true;
      }
    },
    openFancy(url) {
      $.fancybox.open([
        {
          src: url,
          opts: {
            caption: '',
            touch: {
              vertical: false
            },
            btnTpl: {
              close:
                '<button class="fancy-close" aria-label="close" data-fancybox-close><span class="ion-android-close"></span></button>'
            }
          }
        }
      ]);
    },
    // Misc
    convertToUnitySuite(pmObj) {
      let floor = pmObj.floor;
      let suite = pmObj.suite;
      if (floor.length === 1) {
        floor = '0' + floor;
      }
      if (suite.length === 1) {
        suite = '0' + suite;
      }
      return floor + suite;
    },
    activeFilterCount(filterTypes) {
      // return this.filters[filterType].filter((x) => { return x.active === true; }).length;
      return this.filters[filterTypes].filter(x => {
        return x.active === true;
      }).length;
    },
    scrollToTop() {
      $('#floorplans').animate({ scrollTop: 0 }, 500);
    },
    hidePlans() {
      this.inquireOpened = true;
    },
    showPlans() {
      this.inquireOpened = false;
    },
    toggleInput(inputData) {
      const id = 'mobile_' + inputData.name;
      const el = document.getElementById(id);
      if (el.getAttribute('aria-checked') === 'true') {
        inputData.active = false;
      } else {
        inputData.active = true;
      }
    }
  },
  computed: {
    mobileActiveFiltersLevels() {
      let returnStr = '';
      if (this.filters) {
        const levels = this.filters.levels
          .filter(type => type.active)
          .map(type => type.label.replace('levels ', ''));
        levels.forEach((level, index) => {
          if (index === 0) {
            returnStr += 'LEVELS: ' + level;
          } else {
            returnStr += ', ' + level;
          }
        });
      }
      return returnStr;
    },
    mobileActiveFiltersDir() {
      let returnStr = '';
      if (this.filters) {
        const dirs = this.filters.directions
          .filter(type => type.active)
          .map(type => type.label);
        dirs.forEach((dir, index) => {
          if (index === 0) {
            returnStr += dir;
          } else {
            returnStr += ', ' + dir;
          }
        });
      }
      return returnStr;
    },
    mobileActiveFiltersTypes() {
      let returnStr = '';
      if (this.filters && this.activeFilterCount('types') > 0) {
        const types = this.filters.types
          .filter(type => type.active)
          .map(type => type.label);
        types.forEach((type, index) => {
          if (index === 0) {
            returnStr += type;
          } else {
            returnStr += ', ' + type;
          }
        });
      }
      return returnStr;
    },
    planDesc() {
      if (this.filteredPlans[this.planIndex] && this.data) {
        // console.log(this.filteredPlans[this.planIndex])
        const content = this.data.section_content.find(
          data => data.name === this.filteredPlans[this.planIndex].name
        );
        if (content) {
          return content.content;
        }
        return '';
      }
      return '';
    }
  },
  created() {
    EventBus.$on('dataReady', this.setPlans);
    EventBus.$on('closePlan', this.closePlan);

    EventBus.$on('restartFilter', this.restartFilter);
    EventBus.$on('closePlan', this.closePlan);

    EventBus.$on('inquireFloorplanOpen', this.hidePlans);
    EventBus.$on('closeInquire', this.showPlans);
  },
  mounted() {
    this.calcVH();
    window.addEventListener('onorientationchange', this.calcVH, true);
    window.addEventListener('resize', this.calcVH, true);

    this.initSwipe();
    setTimeout(
      () => {
        this.initFancyBox();
      },
      250,
      this
    );

    $('#floorplans').scroll(() => {
      if ($('#floorplans').scrollTop() === 0) {
        $('.top-btn').css('display', 'none');
      } else {
        $('.top-btn').css('display', 'block');
      }
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../globals.scss';

$planPadding: 15px;

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#floorplans {
  // position: absolute;
  // top: 0;
  // left: 0;
  // min-height: 700px;
  // width: 100vw;
  position: relative;

  height: calc(100vh - #{$desktopFooterHeight});
  margin: 0;
  overflow-y: auto;
  // overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background-color: $livmoreBeige;
  transition: all 0.5s ease-out;
  z-index: 8;

  .content {
    position: relative;
  }

  .plan-component {
    position: fixed;
  }

  .show-accessible {
    display: block;
    width: 100%;
    border: none;
    padding: 10px;
    margin-bottom: 10px;

    text-align: center;
    // background: $livmoreRed;
    background: $livmoreBlack;
    color: $livmoreBeige;
    font-family: $chronicleDeck;
    font-weight: $chronicleDeck-Semi;
    font-size: 12px;
    letter-spacing: 1px;

    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    &:active {
      transform: scale(0.95);
    }

    &:hover {
      opacity: 0.8;
    }

    &.hide-btn {
      width: 80%;
      margin: 20px auto;
    }
  }

  .accessible-desc {
    padding: 15px;
    margin-bottom: 20px;
    line-height: 1.5;
    text-align: left;
  }

  .filters {
    // padding-top: 60px;

    padding: 1.5rem 0 0.5rem;
    height: auto;

    box-sizing: border-box;
    // height: 280px;
    // width: 1000px;
    margin-left: auto;
    margin-right: auto;

    display: flex;
    align-items: flex-start;
    // align-items: center;
    justify-content: flex-start;

    text-align: center;

    font-family: $lato;
    font-size: 14px;
    letter-spacing: 1.7px;
    // background-color: $livmoreRed;
    background-color: $livmoreBlack;

    input[type='checkbox'] {
      border: 1px solid $livmoreBeige;
      width: 20px;
      height: 20px;
      background-color: transparent;
    }

    input:focus + label:before {
      box-shadow: 0 0 0 0.25rem rgba(0, 123, 255, .25);
    }

    input,
    span {
      vertical-align: middle;
      margin-top: 3px;
      margin-bottom: 3px;
    }

    .desktop_logo {
      padding-left: 20px;
      margin-top: 20px;
      width: 25%;
      // display:flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: center;
      // height: 100%;
    }

    .filter-block {
      width: 25%;
      // min-width: 350px;

      // padding-left: 100px;
      text-align: left;
      display: flex;
      // align-items: center;
      justify-content: center;

      &:nth-of-type(1) {
        text-align: center;
      }

      div.checkbox_row {
        margin-top: 15px;
        margin-bottom: 15px;
      }

      div.checkbox_row:first-of-type {
        margin-top: 7px;
      }

      .title {
        font-family: $chronicleDeck;
        color: $livmoreBeige;
        text-transform: uppercase;
        text-align: left;

        font-size: 24px;
        margin-bottom: 30px;
        letter-spacing: 1px;
        // width: 50%;
        // min-width: 165px;
        // min-width: 130px;
        padding-right: 20px;
        float: left;
        display: inline-block;

        margin-block-start: 0px;
        margin-block-end: 0px;

        &.level {
          min-width: 100px;
        }
      }

      .checkbox_container {
        width: 50%;
        float: left;
        display: inline-block;
      }
    }
  }

  .filters_mobile {
    display: none;
    opacity: 0;
    transition: opacity 0.5s ease-out;
    background: $livmoreBeige;

    pointer-events: none;
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;

    height: calc(100vh - 75px);
    width: 100vw;
    // padding: 10px;

    .selected_filters {
      color: $livmoreBlack;
      text-align: left;
      padding-left: 30px;
      font-family: $lato;
      font-weight: $lato-Bold;
      font-size: 1em;

      span {
      }

      &:first-of-type {
        margin-top: 10px;
      }
    }

    .next_container {
      position: absolute;
      width: 80%;
      margin: 0 auto;

      bottom: calc(0px + 75px + 10px);
      left: 50%;
      transform: translateX(-50%);
      transition: all 0.15s ease-out;

      .next_btn {
        display: block;
        width: 100%;
        border: none;
        padding: 10px;
        margin-bottom: 10px;

        text-align: center;
        // background: $livmoreRed;
        background: $livmoreBlack;
        color: $livmoreBeige;
        font-family: $chronicleDeck;
        font-weight: $chronicleDeck-Semi;
        font-size: 18px;
        letter-spacing: 1px;

        cursor: pointer;
        user-select: none;
        -webkit-tap-highlight-color: transparent;

        &:active {
          transform: scale(0.95);
        }

        &:hover {
          opacity: 0.8;
        }
      }

      .skip_btn {
        display: block;
        width: 100%;
        border: none;
        background: none;
        font-family: $mainFont;
        // color: $livmoreRed;
        color: $livmoreBlack;
        line-height: 2;
        text-align: center;

        cursor: pointer;
        user-select: none;
        -webkit-tap-highlight-color: transparent;

        &:active {
          transform: scale(0.95);
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .filter-block {
      height: calc(100vh - 75px - 75px - 35px);
      width: 100vw;
      position: absolute;
      // top: calc(75px + 35px);
      top: calc(75px + 25px);
      left: 0;
      // padding: 10px;
      background: $livmoreBeige;
      opacity: 0;
      transition: opacity 0.5s ease-out;
      pointer-events: none;
      text-align: left;

      &.mobile {
        display: none;
      }

      .title {
        font-family: $chronicleDeck;
        font-weight: $chronicleDeck-Semi;
        margin-top: 10px;
        margin-left: 30px;
        margin-right: 20px;
        margin-bottom: 60px;
        // color: $livmoreRed;
        color: $livmoreBlack;
        font-size: 30px;

        .title_num {
          display: inline-block;
          width: 25px;
          vertical-align: top;
        }
        .title_question {
          display: inline-block;
          width: 80%;
          vertical-align: top;
          font-size: 30px;
          margin-top: 0px;
          margin-bottom: 0px;
        }
      }

      .checkbox_container {
        margin-left: 35px;

        .checkbox_row {
          margin-bottom: 30px;
          .checkbox {
          }
          label {
          }
        }
      }

      &.active {
        display: block;
        opacity: 1;
        pointer-events: all;
      }
    }

    &.active {
      opacity: 1;
      pointer-events: all;
    }
  }

  .plan-list {
    margin-top: 60px;

    .no_plans {
      color: $livmoreRed;
      padding-top: 50px;
      font-size: 20px;
      text-align: center;
      letter-spacing: 1px;
    }

    .swipe {
      font-family: $lato;
      font-weight: $lato-Bold;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      position: relative;

      span {
        display: inline-block;
      }

      .mobile-plan-nav {
        background: $livmoreBeige;
        border: none;
        font-size: 15px;
        position: absolute;
        top: 0;

        &.icon-arrow-left {
          left: 2px;
        }

        &.icon-arrow-right {
          right: 2px;
        }
      }
    }

    .plan {
      display: inline-block;
      margin: 20px 15px;

      padding: $planPadding 0px 0px;
      border: 1px solid black;

      position: relative;

      .occupancy {
        border: 1px solid black;
        position: absolute;
        transform: translateY(calc(-50% - #{$planPadding})) translateX(-50%);
        left: 50%;
        width: 50%;
        color: $livmoreRed;
        z-index: 1;
        background-color: $livmoreBeige;
        margin: 0 auto;
        padding: 7px 10px;
      }

      .fp_thumb_container {
        margin: 20px;

        .fancy_thumb {
          display: block;
          outline: none;
          height: 100%;

          &:focus {
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
          }
        }

        .fp_thumb {
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;

          transition: background-image 0.25s ease-in-out;

          width: 340px;
          height: 300px;
          // margin: 20px 20px 20px 20px;
        }
      }

      .details_container {
        border-top: 1px solid black;

        .details {
          // border-top: 1px solid black;
          text-align: left;
          padding: 29px 31px;

          .title {
            color: $livmoreRed;
            // color: $livmoreRed;
            color: $livmoreBlack;
            margin-bottom: 10px;
            font-size: 18px;
          }

          .detail_block {
            width: 49%;
            display: inline-block;
            box-sizing: border-box;
            vertical-align: top;
            margin: 0px 0px 20px;
            font-size: 12px;

            .bed-type {
              margin-bottom: 5px;
            }
            .size {
            }

            .direction {
              margin-bottom: 5px;
            }
            .baths {
            }
          }
          .detail_block:nth-of-type(3) {
            text-align: right;
          }

          .view {
            button {
              // background-color: $livmoreRedAccessible;
              // color: $white;
              background-color: $livmoreBlack;
              color: $livmoreBeige;
              width: 100%;

              line-height: 2.5;
              font-family: $chronicleDeck;
              border: none;
              font-size: 1rem;
              cursor: pointer;
              user-select: none;
              -webkit-tap-highlight-color: transparent;

              transition: all 0.5 ease-out;

              &:active {
                transform: scale(0.95);
              }

              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }
    }

    &.mobile {
      border: none;
      display: none;
      overflow-y: hidden;
      // background-color: Black;

      .plan {
        border: 0px;
        -webkit-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
        -moz-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
        // height: 100vw;
        margin-left: 30px;
        margin-right: 30px;

        .details_container {
          border-top: 0px;
        }
      }

      &.filterActive {
        overflow-y: hidden;
        display: none;
      }
    }
  }

  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    margin-top: 150px;
    img {
      margin-bottom: 20px;
    }
  }

  .top-btn {
    cursor: pointer;
    // background: $livmoreRed;
    // color: $livmoreBeige;
    background-color: $livmoreBlack;
    color: $livmoreBeige;
    border: none;
    padding: 10px;

    position: fixed;
    bottom: calc(20px + #{$desktopFooterHeight});
    right: 20px;

    display: none;
  }

  /* Custom checkbox */
  .custom-check[type='checkbox']:not(:checked),
  .custom-check[type='checkbox']:checked {
    position: absolute;
    left: -9999px;
  }
  .custom-check[type='checkbox']:not(:checked) + label,
  .custom-check[type='checkbox']:checked + label {
    position: relative;
    padding-left: 2.5em;
    padding-top: 2px;
    cursor: pointer;
    user-select: none;
    text-transform: uppercase;
    color: $livmoreBeige;
  }

  /* checkbox aspect */
  .custom-check[type='checkbox']:not(:checked) + label:before,
  .custom-check[type='checkbox']:checked + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 1.25em;
    height: 1.25em;
    border: 1px solid $livmoreBeige;
    background: #transparent;
    border-radius: 0px;
  }
  /* checked mark aspect */
  .custom-check[type='checkbox']:not(:checked) + label:after,
  .custom-check[type='checkbox']:checked + label:after {
    content: '';
    position: absolute;
    background-color: $livmoreBeige;
    height: 0.95em;
    width: 0.95em;
    top: 0;
    left: 0;
    font-size: 1.4em;
    line-height: 0.8;
    color: #09ad7e;
    transition: all 0.2s;
  }
  /* checked mark aspect changes */
  .custom-check[type='checkbox']:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0);
  }
  .custom-check[type='checkbox']:checked + label:after {
    opacity: 1;
    transform: scale(1);
  }
  /* disabled checkbox */
  .custom-check[type='checkbox']:disabled:not(:checked) + label:before,
  .custom-check[type='checkbox']:disabled:checked + label:before {
    box-shadow: none;
    border-color: #bbb;
    background-color: #ddd;
  }
  .custom-check[type='checkbox']:disabled:checked + label:after {
    color: #999;
  }
  .custom-check[type='checkbox']:disabled + label {
    color: #aaa;
  }

  &.planActive {
    overflow-y: hidden;
  }

  &.hidden {
    display: none;
  }
}

@media screen and (min-width: 1281px) and (orientation: landscape) {
  #floorplans {
    height: calc(100vh - #{$desktopFooterHeight});
  }
}

@media screen and (max-width: 1280px) {
  #floorplans {
    height: calc(100vh - #{$desktopFooterHeight1280});

    .plan-component {
    }

    .filters {
      height: auto;
      padding-top: 30px;
      padding-bottom: 10px;
      // align-items: center;
      // justify-content: center;
      vertical-align: top;
      // margin: 0 auto;
      text-align: center;

      .desktop_logo {
        display: none;
      }

      .filter-block {
        width: 33%;
        display: inline-block;
        // vertical-align: top;
        margin: 0 auto;
        width: auto;

        .title {
          font-size: 20px;
          margin-bottom: 15px;
          display: block;
          width: 100%;
        }

        .checkbox_container {
          display: block;
          width: 100%;
        }
      }
    }

    .top-btn {
      bottom: calc(20px + #{$desktopFooterHeight1280});
    }
  }
}

@media screen and (max-width: 1024px) {
  #floorplans {
    height: calc(100vh - 100px);

    .filters {
      padding-top: 20px;
    }
  }
}

@media screen and (max-width: 768px) {
  #floorplans {
    height: calc(100vh - 100px);

    .filters {
      // padding-top: 30px;

      .filter-block {
        // margin: 0 auto;
        padding-left: 30px;
        // display: block;
        width: auto;

        .title {
          font-size: 20px;
          margin-bottom: 15px;
        }
        .checkbox_container {
          width: auto;
        }
      }
    }

    .plan-list {
      .plan {
        .occupancy {
          width: 65%;
        }
        .fp_thumb_container {
          .fp_thumb {
            width: 270px;
            height: 250px;
          }
        }
        .details_container {
          .details {
            .detail_block {
              margin-bottom: 10px;
            }
          }
        }
      }
    }

    /* Custom checkbox */

    .custom-check[type='checkbox']:not(:checked) + label,
    .custom-check[type='checkbox']:checked + label {
      padding-left: 2.5em;
      padding-top: 2px;
    }

    /* checkbox aspect */
    .custom-check[type='checkbox']:not(:checked) + label:before,
    .custom-check[type='checkbox']:checked + label:before {
      width: 1.15em;
      height: 1.15em;
    }
    /* checked mark aspect */
    .custom-check[type='checkbox']:not(:checked) + label:after,
    .custom-check[type='checkbox']:checked + label:after {
      height: 0.88em;
      width: 0.88em;
      font-size: 1.4em;
      line-height: 0.8;
    }
  }
}

@media screen and (max-width: 767px) {
  #floorplans {
    height: calc(100vh - 75px);
    margin-bottom: 75px;

    .filters {
      display: none;
    }

    .filters_mobile {
      display: none;

      &.active {
        display: block;
      }
    }

    .plan-list {
      display: none;

      .plan {
        display: block;
        height: calc(78vh - 75px);
        // height: calc(70vh - 75px - 75px);
        // height: 100%;

        .occupancy {
          width: 65%;
        }

        .fp_thumb_container {
          height: calc(100% - 256px);
          .fp_thumb {
            width: 100%;
            // height: calc(70vh - 182px);
            height: 100%;
          }
        }

        .details_container {
          .details {
            padding: 10px 15px;

            .detail_block {
              .bed-type {
                margin-bottom: 0px;
              }
            }
            .detail_block:nth-of-type(3) {
            }

            .view {
              button {
                line-height: 2.5;
                margin-bottom: 10px;
              }
            }
          }
        }
      }

      &.mobile {
        display: block;
        margin-top: 20px;


        &.hidden {
          display: none;
        }
      }
    }

    .top-btn {
      display: none !important;
    }
    /* Custom checkbox */

    .custom-check[type='checkbox']:not(:checked) + label,
    .custom-check[type='checkbox']:checked + label {
      padding-left: 2.5em;
      padding-top: 3px;
      color: $livmoreBlack;
      font-family: $lato;
      letter-spacing: 2px;
      font-size: 17px;
    }

    /* checkbox aspect */
    .custom-check[type='checkbox']:not(:checked) + label:before,
    .custom-check[type='checkbox']:checked + label:before {
      width: 1.45em;
      height: 1.45em;
      border: 1px solid $livmoreRed;
    }
    /* checked mark aspect */
    .custom-check[type='checkbox']:not(:checked) + label:after,
    .custom-check[type='checkbox']:checked + label:after {
      height: 1.075em;
      width: 1.075em;
      font-size: 1.4em;
      line-height: 0.8;
      background-color: $livmoreRed;
    }

    .show-accessible {
      font-size: 10px;
    }
  }
}

@media screen and (max-width: 415px) {
  #floorplans {
    height: calc(100vh - 75px);
    // margin-bottom: 75px;

    .filters {
      display: none;
    }

    .filters_mobile {
      height: calc(100% - 0px);
      width: 100vw;
      // padding: 10px;

      .selected_filters {
        padding-left: 30px;
        font-size: 1em;

        &:first-of-type {
          margin-top: 20px;
        }
      }

      .next_btn {
        text-align: center;
        letter-spacing: 1px;

        &:active {
          transform: translateX(-50%) scale(0.95);
        }
        &:hover {
          opacity: 0.8;
        }
      }

      .filter-block {
        .title {
          margin-top: 0px;
          margin-left: 30px;
          margin-right: 15px;
          margin-bottom: 10px;
          font-size: 20px;

          .title_num {
            display: inline-block;
            width: 25px;
            vertical-align: top;
          }
          .title_question {
            display: inline-block;
            width: 80%;
            vertical-align: top;
            margin-top: -10px;
            font-size: 18px;
          }
        }

        .checkbox_container {
          margin-left: 35px;

          .checkbox_row {
            margin-bottom: 20px;
          }
        }

        &.active {
          opacity: 1;
          pointer-events: all;
        }
      }

      &.active {
        opacity: 1;
        pointer-events: all;
      }
    }

    .plan-list {
      display: none;

      .plan {
        height: calc(70vh - 55px);
        // height: calc(70vh);
        padding: 15px;

        .occupancy {
          width: 65%;
        }

        .fp_thumb_container {
          margin: 5px;
          height: calc(100% - 196px);
          .fp_thumb {
            // height: calc(70vh - 196px);
            height: 100%;
          }
        }

        .details_container {
          .details {
            .title {
              font-size: 16px;
            }

            .detail_block {
              font-size: 11px;
            }

            .view {
              button {
                font-size: 0.80rem;
              }
            }
          }
        }
      }

      &.mobile {
        display: block;
        margin-top: 20px;

        .swipe {
          font-size: 10px;

          .mobile-plan-nav {
            font-size: 13px;
          }
        }
      }
    }

    /* Custom checkbox */
    [type='checkbox']:not(:checked) + label,
    [type='checkbox']:checked + label {
      padding-left: 2.5em;
      padding-top: 2px;
      color: $livmoreBlack;
      font-family: $lato;
      letter-spacing: 2px;
      font-size: 14px;
    }

    /* checkbox aspect */
    [type='checkbox']:not(:checked) + label:before,
    [type='checkbox']:checked + label:before {
      width: 1.25em;
      height: 1.25em;
      border: 1px solid $livmoreRed;
    }
    /* checked mark aspect */
    [type='checkbox']:not(:checked) + label:after,
    [type='checkbox']:checked + label:after {
      height: 0.95em;
      width: 0.95em;
      font-size: 1.4em;
      line-height: 0.8;
      background-color: $livmoreRed;
    }
  }
}

@media screen and (max-width: 415px) and (max-height: 568px) {
  #floorplans {
    height: calc(100vh - 75px);
    // margin-bottom: 75px;

    .filters {
      display: none;
    }

    .filters_mobile {
      height: calc(100% - 0px);
      width: 100vw;
      // padding: 10px;

      .selected_filters {
        padding-left: 30px;
        font-size: 14px;

        &:first-of-type {
          margin-top: 20px;
        }
      }



      .next_container {
        width: 80%;
        margin: 0 auto;

        bottom: 75px;


        .next_btn {
          letter-spacing: 1px;
          padding: 10px;
          margin-bottom: 10px;
          font-size: 14px;
        }

        .skip_btn {
        }
      }

      .filter-block {
        .title {
          margin-top: 0px;
          margin-left: 30px;
          margin-right: 15px;
          margin-bottom: 10px;
          font-size: 20px;

          .title_num {
            font-size: 16px;
          }
          .title_question {
            display: inline-block;
            width: 80%;
            vertical-align: middle;
            margin-top: -10px;
            font-size: 16px;
          }
        }

        .checkbox_container {
          margin-left: 35px;

          .checkbox_row {
            margin-bottom: 20px;
          }
        }

        &.active {
          opacity: 1;
          pointer-events: all;
        }
      }

      &.active {
        opacity: 1;
        pointer-events: all;
      }
    }

    .plan-list {
      display: none;

      .plan {
        height: calc(70vh - 55px);
        // height: calc(70vh);
        padding: 15px;

        .occupancy {
          width: 65%;
        }

        .fp_thumb_container {
          margin: 5px;
          height: calc(100% - 196px);
          .fp_thumb {
            // height: calc(70vh - 196px);
            height: 100%;
          }
        }

        .details_container {
          .details {
            .title {
              font-size: 16px;
            }

            .detail_block {
              font-size: 11px;
            }

            .view {
              button {
                font-size: 0.80rem;
              }
            }
          }
        }
      }

      &.mobile {
        display: block;
        margin-top: 20px;

        .swipe {
          font-size: 8px;

          .mobile-plan-nav {
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/Floorplans.vue